<template>
    <div>
        <el-dialog title="选择商品" :visible.sync="visible" width="1200px" :close-on-click-modal="false">
            <el-row style="margin-top: -20px" type="flex" justify="space-between">
                <div></div>
                <el-form size="small" :model="query" inline @submit.native.prevent>
                    <el-form-item>
                        <el-input v-model="query.search_keyword" placeholder="请输入商品标题" clearable @keyup.enter.native="handleSearch"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch">搜索</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row :gutter="20" style="min-height: 500px">
                <el-col :span="7">
                    <el-button type="text" style="all-btn" @click="handleAll">全部分类</el-button>
                    <el-tree
                        ref="tree"
                        node-key="uuid"
                        highlight-current
                        :expand-on-click-node="false"
                        :data="categories"
                        :props="defaultProps"
                        @node-click="handleNodeClick"
                    ></el-tree>
                </el-col>
                <el-col :span="17">
                    <el-radio-group style="width: 100%" v-model="pickedUUid">
                        <el-table
                            v-loading="loading"
                            :data="tableData"
                            row-key="uuid"
                            ref="table"
                            size="small"
                            header-cell-class-name="table-header"
                            border
                            style="margin: 20px 0"
                        >
                            <el-table-column prop="name" label="商品名称" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="category.name" label="商品类别" show-overflow-tooltip></el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template slot-scope="{ row }">
                                    <el-radio :label="row.uuid"><span style="font-size: 0">1</span></el-radio>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-radio-group>
                    <el-row type="flex" justify="end">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="query.page_index"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                        >
                        </el-pagination>
                    </el-row>
                </el-col>
            </el-row>
            <span slot="footer">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" @click="handleConfirm">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import listMixin from "@/mixins/list";
import { list as categoryList } from "@/api/product/category";
import { list } from "@/api/product/list";
export default {
    data() {
        return {
            list,
            visible: false,
            query: {
                search_keyword: "",
                search_category_uuid: "",
                type: "",
            },
            categories: [],
            defaultProps: {
                children: "children",
                label: "name",
            },
            pickedUUid: "",
        };
    },
    mounted() {
        this.getCategories(1);
        this.getCategories(2);
    },
    mixins: [listMixin],
    methods: {
        open() {
            this.visible = true;
            this.pickedUUid = "";
            this.search();
        },
        search() {
            this._search();
        },
        getCategories(type) {
            categoryList({ page_index: 1, page_size: 9999, type }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.categories.push({ name: type == 1 ? "连接器" : "工具", uuid: type, children: result.data, root: true });
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleAll() {
            this.query.search_category_uuid = "";
            this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(null);
            });
            this.search();
        },
        handleNodeClick(data) {
            if (data.root) return;
            this.query.search_category_uuid = data.uuid;
            this.search();
        },
        handleConfirm() {
            if (this.pickedUUid) {
                const name = this.tableData.find((item) => item.uuid === this.pickedUUid).name;
                const cuuid = this.tableData.find((item) => item.uuid === this.pickedUUid).cuuid;
                this.$emit("pick", { name, uuid: this.pickedUUid, cuuid });
                this.visible = false;
            } else {
                this.$message.warning("请选择商品");
            }
        },
    },
};
</script>

<style lang="less" scoped>
:deep(.el-radio__label) {
    padding-left: 0;
}
.all-btn {
    position: relative;
    top: -20px;
    font-weight: bold;
    color: #333;
}
</style>
